// extracted by mini-css-extract-plugin
export default {"root":"Galery_root__gQ0dO","image_grid":"Galery_image_grid__WiAOK"};